import React from 'react'
import ContentLoader from './ContentLoader'
import { IContentLoaderProps } from 'react-content-loader'

const TextPlaceholder: React.FC<IContentLoaderProps> = (props): JSX.Element => (
	<ContentLoader height={60} width="100%" viewBox="0 0 1200 60" {...props}>
		<rect x="0" y="0" rx="6" ry="6" width="90%" height="6" />
		<rect x="0" y="20" rx="6" ry="6" width="60%" height="6" />
		<rect x="0" y="40" rx="6" ry="6" width="15%" height="6" />
	</ContentLoader>
)

export default TextPlaceholder
